import { ref } from 'vue';

// La app sólo entra al estado offline después de que una solicitud real falla.
// Al reanudarse, navigator.onLine se usa únicamente para salir de ese estado,
// sin hacer una solicitud de sondeo al servidor.
export const networkOnline = ref(true);

let started = false;

export function startConnectivityTracking(): void {
  if (started) return;
  started = true;
  window.addEventListener('online', refreshConnectivityAfterResume);
  window.addEventListener('focus', refreshConnectivityAfterResume);
  document.addEventListener('visibilitychange', handleVisibilityChange);
}

export function stopConnectivityTracking(): void {
  if (!started) return;
  started = false;
  window.removeEventListener('online', refreshConnectivityAfterResume);
  window.removeEventListener('focus', refreshConnectivityAfterResume);
  document.removeEventListener('visibilitychange', handleVisibilityChange);
}

export function refreshConnectivityAfterResume(): boolean {
  if (!networkOnline.value && navigator.onLine) networkOnline.value = true;
  return networkOnline.value;
}

export function markNetworkRequestSucceeded(): void {
  networkOnline.value = true;
}

export function markNetworkRequestFailed(cause: unknown): void {
  const message = cause instanceof Error ? cause.message : '';
  if (!navigator.onLine || cause instanceof TypeError || /failed to fetch|network request failed|networkerror|load failed|internet connection/i.test(message)) {
    networkOnline.value = false;
  }
}

function handleVisibilityChange(): void {
  if (!document.hidden) refreshConnectivityAfterResume();
}
